import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              焦点专题
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              深度策划的网红圈焦点专题，一次看全
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {carouselItems.map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <span className="absolute bottom-3 left-4 inline-block px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
                    {item.subtitle}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}